export const DEFAULT_METRICS_HISTOGRAM = '1000_1500_2000_2500_3000_4000';

export const BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION = '2QE2xWf0TpDbYpk4oY9aQr';
export const BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID = `${BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION}.config-disabled-section.article.analytics`;

export const DEFAULT_LEVEL_ONE_NAME = 'Epic';

export const boardSettingsQueryConfigParamValues = {
	cardColors: 'cardColors',
	cardLayout: 'cardLayout',
	columns: 'columns',
	estimation: 'estimation',
	general: 'filter',
	swimlanes: 'swimlanes',
	workingDays: 'time',
	timeline: 'timelineConfig',
	quickFilters: 'quickFilters',
	insights: 'insightsConfig',
} as const;

export const HEAVY_TEST_TIMEOUT = 60000;

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const EDIT_BOARD_CONFIG = 'EDIT_BOARD_CONFIG' as unknown as AGG$SoftwareBoardPermission;
export const ADMINISTER_PARENT_PROJECT =
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	'ADMINISTER_PARENT_PROJECT' as unknown as AGG$SoftwareBoardPermission;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const BACKLOG_FEATURE_KEY = 'BACKLOG' as unknown as AGG$SoftwareBoardFeatureKey;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const SPRINTS_FEATURE_KEY = 'SPRINTS' as unknown as AGG$SoftwareBoardFeatureKey;
export const USER_PICKER_PROJECT_PERMISSION_KEY = 'USER_PICKER';
export const ADMINISTER_PROJECT_PERMISSION_KEY = 'ADMINISTER';
